import ListingApplicationsApplicationSection from './ListingApplicationsApplicationSection';

export default ListingApplicationsApplicationSection;
